import React from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    EmailField,
    ReferenceField,
    TopToolbar,
    EditButton,
    useRecordContext,
} from 'react-admin';
import {
    Grid
} from '@mui/material';
import { Email} from "../../types/entities";

const ShowActions = () => {

    return (
        <TopToolbar>
            <EditButton />
        </TopToolbar>
    );
}

const ShowUrlTitle = () => {
    const record: Email = useRecordContext();
    if (!record) return null;
    return <span>{ "Url - " + record.id }</span>
}

export const AdminEmailShow = () => {

    return(
        <Show actions={ <ShowActions /> } title={ <ShowUrlTitle /> }>
            <Grid container spacing={ 2 }>
                <Grid size={ 6 }>
                    <SimpleShowLayout>
                        <TextField source="id"/>
                        <EmailField source="email" />

                    </SimpleShowLayout>
                </Grid>
                <Grid size={ 6 }>
                    <SimpleShowLayout>
                        <TextField source="description" />
                        <ReferenceField
                            source="company"
                            reference="companies"
                            link="edit"
                        >
                            <TextField source="name"/>
                        </ReferenceField>
                    </SimpleShowLayout>
                </Grid>
            </Grid>
        </Show>
    );
}